import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import axios from "axios";

const updateOrderItemStatus = async ({ orderId, itemId, status }, token) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_SERVER_URL}/order/orders/${orderId}/items/${itemId}/status`,
    { status },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

const useUpdateOrderItemStatus = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({ orderId, itemId, status }) =>
      updateOrderItemStatus({ orderId, itemId, status }, token),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("merchantOrders");
        queryClient.invalidateQueries("myOrders");
        queryClient.invalidateQueries("allOrders");
      },
    }
  );
};

export default useUpdateOrderItemStatus;
